import { createDefaultRecipientRoleFieldBase } from './default-recipient-role-field';
import { Field } from './fields';
import { FieldEnum, FieldTypeEnum, SelectedFieldEnum } from './fields.dto'

const withCalculation = (field: Field) => ({
  connected_parent_calculation_id: field.connected_parent_calculation_id ?? [],
});

export const MultichoiceField = {
    tag(field) {
        return {
            ...createDefaultRecipientRoleFieldBase(field, true),
            field_name: "List",
            field: FieldEnum.ListField,
            type: FieldTypeEnum.List,
            selected_field: SelectedFieldEnum.ListField,
            multi_choice: field.multi_choice ?? 0,
            hide_label: field.hide_label ?? 0,
            options: field.options ?? [],
            column: field.column ?? "50",
            ...withCalculation(field)
        }
    }
}
